const navigation = (): void => {
  // Page Scroll

  const pageScrollNavStyle = (): void => {
    window.addEventListener('scroll', () => {
      const body = document.querySelector<HTMLElement>('body'),
        scrollAmount: number = window.pageYOffset | document.body.scrollTop;

      if (scrollAmount > 100) {
        body.classList.add('page--scrolled');
      } else {
        body.classList.remove('page--scrolled');
      }
    });
  };

  pageScrollNavStyle();

  // Navigation - Featured Articles

  const navItem = document.querySelectorAll('#menu-header > li');

  navItem.forEach((element) => {
    const navArticleSource = element.querySelector<HTMLElement>(
        '.sub-menu__grid .grid__column--menu .sub-menu .article__inner'
      ),
      navArticleLocation = element.querySelector<HTMLElement>(
        '.menu-item-level-0 > .sub-menu__grid > .grid__column--article > .article'
      );

    if (navArticleSource) {
      const navArticleSourceLink = navArticleSource.getAttribute('href');
      navArticleLocation.setAttribute('href', navArticleSourceLink);
      navArticleSource.removeAttribute('href');
      navArticleLocation.appendChild(navArticleSource);
    }
  });

  // Navigation - Mobile Toggle

  const navToggle = document.querySelectorAll<HTMLElement>('.nav__toggle'),
    body = document.querySelector<HTMLElement>('body'),
    hamburger = document.querySelector<HTMLElement>('.nav__toggle--hamburger');

  navToggle.forEach((element) => {
    element.addEventListener('click', () => {
      body.classList.toggle('nav--visible');
      hamburger.classList.toggle('is-active');
    });
  });

  // Navigation - Accordions

  const toggles = document.querySelectorAll<HTMLElement>('.accordion__toggle');

  toggles.forEach((toggle) => {
    // Preapre Accordions

    const parent = toggle.parentElement;
    const grandParent = parent.parentElement;
    const accordionElement = toggle.getAttribute(
      'data-main-menu-accordion-control'
    );

    grandParent.prepend(toggle);
    parent.remove();

    const accordionSubMenu = toggle.nextElementSibling;
    accordionSubMenu.classList.remove('sub-menu');
    accordionSubMenu.classList.add('accordion__collapse');
    accordionSubMenu.setAttribute(
      'data-main-menu-accordion-collapse',
      accordionElement
    );

    // Accordion Toggles

    toggle.addEventListener('click', () => {
      toggle.classList.toggle('accordion__toggle--open');
      accordionSubMenu.classList.toggle('accordion__collapse--open');
    });
  });
};

export default navigation;
